import React from 'react';
import Logo from '../../../components/Logo';
import { SchoolInfoContainer, SchoolName } from './styled';
import { SchoolConfig } from '../../../types/schoolConfigType';

const SCHOOLS_WITH_HIDDEN_CODE = ['XAVIER-KORBA'];

interface SchoolInfoProps {
  school: string;
  schoolConfig: SchoolConfig;
}

const SchoolInfo = ({ school, schoolConfig }: SchoolInfoProps) => {
  const hideSchoolCode = SCHOOLS_WITH_HIDDEN_CODE.includes(school);

  return (
    <SchoolInfoContainer>
      <Logo school={school} schoolConfig={schoolConfig} />
      {!hideSchoolCode && <SchoolName>{school}</SchoolName>}
    </SchoolInfoContainer>
  );
};

export { SchoolInfo };
